import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text8 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, registeredArea} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(registeredArea) && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>שטח רשום: </span>
          <span>{registeredArea} </span>
          <span>מ"ר</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text8;
